import React, { useState, useEffect, useMemo } from 'react';
import {Collapse, Card, CardBody, CardHeader, Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Form } from "react-bootstrap";

import expandIcon from "assets/img/expand-30.png";
import downloadIcon from "assets/img/download-30.png";

import TomSelect from 'tom-select';
import 'tom-select/dist/css/tom-select.css';
import html2canvas from 'html2canvas';

export const CardFrame = ({ Graphs, GraphIndex }) => {
    const Graph = Graphs[GraphIndex].Graph;
    const Title = Graphs[GraphIndex].Title;
    
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);
    
    const downloadGraph = () => {
        const chartContainer = document.getElementById(`graph-container${GraphIndex}`);
        html2canvas(chartContainer).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = imgData;
        link.download = Title;
        link.click();
        });
    }

    const [selected, setSelected] = useState({}); // State to track selected value

    const handleGraphCompareSelected = (selectValue) => {
        setSelected({[selectValue]: true})
    }

    const GraphSelector = () => {
        useEffect(() => {
            new TomSelect('#graphCompareSelect', {
                placeholder: 'Select a graph to compare',
                create: false,
                items: Object.keys(selected)[0]
            });
        }, []);
        
        return (
            <Form.Group as={Row} className='align-items-center mb-2'>
                <Form.Label style={ {fontSize:'12px'} } column xs={2}>
                    {'Select graph to compare'.toUpperCase()}
                </Form.Label>
                <Col xs={10} className='busutil-select-wrapper'>
                    <div className="tom-select-wrapper">
                        <select
                        id={`graphCompareSelect`}
                        defaultValue={null}
                        onChange={(e) => handleGraphCompareSelected(e.target.selectedOptions[0].value)}
                        >
                            {Graphs && Graphs.map((Graph, index) => (
                                <option value={index}>{Graph.Title}</option>
                            ))}
                        </select>
                    </div>
                </Col>
            </Form.Group>
        )
    }

    const PreviewModal = useMemo(() => {
        return (
            <Modal
            className='GraphPreviews' 
            isOpen={modal} 
            toggle={toggle} 
            fullscreen>
            <ModalHeader className='bg-dark text-white text-center p-3' toggle={toggle}>{Title}</ModalHeader>
                <ModalBody className="m-0 mt-1 p-1">
                    <Row>
                        <Col>
                            {Object.values(selected).every(value => value === false) ? 
                            (<div style={{height: "65vh"}}>{Graph}</div>):
                            (<div style={{height: "41vh"}}>{Graph}</div>)}
                        </Col>
                    </Row>
                    <Row>
                        <Col className='m-0 ml-3 mr-3'>
                            <GraphSelector />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {Graphs.map((Graph, index) => (
                                <Collapse 
                                key={index}
                                isOpen={selected[index]}
                                >
                                    <div style={{height: "41vh"}}>{Graph.Graph}</div>
                                </Collapse>
                            ))}
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="btn bg-warning text-white" onClick={() => {setSelected({})}}>
                        Clear
                    </Button>{' '}
                    <Button className='btn bg-danger text-white' onClick={toggle}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        )
    })

    return (
        <>  
            {PreviewModal}
            <Card className="shadow rounded">
                <CardHeader className="bg-dark text-white">
                    <Row>
                        <Col>
                            {Title}
                        </Col>
                        <Col className="d-flex justify-content-end">
                            <div className="p-0 m-0 hover-highlight" style={{ height: "15px" }}>
                                <span 
                                className='p-3'
                                onClick={downloadGraph} 
                                style={{ cursor: 'pointer' }}>
                                    <img src={downloadIcon} alt="Download" />
                                </span>
                                <span onClick={toggle} style={{ cursor: 'pointer' }}>
                                    <img src={expandIcon} alt="Expand Icon" />
                                </span>
                            </div>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody className="m-0 mt-1 p-1">
                    <div id={`graph-container${GraphIndex}`} style={{height: "30vh"}}>{Graph}</div>
                </CardBody>
            </Card>
        </>
    );
};
